import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  open() {
    setTimeout(() => {
      const joinUrl = document.querySelector("#zoom-join-url").dataset.joinUrl
      if (joinUrl) {
        window.open(joinUrl, "_blank", "noopener,noreferrer")
      }
    }, 500)
  }

}
